export default {"src":"/_next/static/media/logo_ring.bc5937a2.svg","height":216,"width":269};